/* 수주관리 */
import { useState , useEffect, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useContract } from '../../stores/contract/ContractAction';
import { useContractAPI } from '../../api/contract/useContractAPI';
import { columns, formFields, searchFormFields } from './context';

import FileManagement from '../../components/Modal/File/FileManagement';
import Search from '../../components/Search/Search';
import Table from '../../components/Table/Table/Table';
import EmptyState from '../../components/EmptyState';
import { LIST_EMPTY } from '../_shared/listEmptyState';
import BaseModal from '../../components/Modal/Base/BaseModal';
import CrudModal from '../../components/Modal/Crud/CrudModal';
import ConfirmModal from '../../components/Modal/Confirm/ConfirmModal';
import ExcelImportResultModal from '../../components/Modal/ExcelImportResult/ExcelImportResultModal';
import ContractStatDashboard from './ContractStatDashboard';
import m from '../../utils/date'

import { FaInfo } from 'react-icons/fa';
import { PiFloppyDiskBold } from "react-icons/pi";
import { FaClipboardList } from 'react-icons/fa';
import './ContractManagement.css';

const ContractManagement = () => {

  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const contracts = useSelector((state) => state.contract);
  const contract = useContract();
  const contractDirectApi = useContractAPI();
  const [content, setContent] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [importResult, setImportResult] = useState(null);
  const [importResultOpen, setImportResultOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchParams, setSearchParams] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: 'contractDt', direction: 'desc' });
  const [statRefresh, setStatRefresh] = useState(0);
  const [lastContractDt, setLastContractDt] = useState(null);
  
  // type 1 : 등록, 2 : 수정
  const openModal = (type, row = null) => {
    let action;
      if(type === 1){
        setModalTitle(
          <><FaClipboardList style={{ marginRight: '8px' }} /> 수주 등록</>
        )
        action = addContract;
      } else {
        setModalTitle(<><FaClipboardList style={{ marginRight: '8px' }} /> 수주 수정</>)
        action = updateContract;
      }
    setIsOpen(true);
    setContent(
    <CrudModal
      type={type}
      formFields={formFields}
      formDatas={row || {}}
      onClose={closeModal}
      onSubmit={action}
    />);
  };
  const openFileModal = (row) => {
    if (!row) {
      return;
    }
    setIsOpen(true);
    setContent(
      <FileManagement
        row={row}
        fileCode={"Contract"}
        onClose={closeModal} 
      />);
    setModalTitle(<><PiFloppyDiskBold size={20} style={{ marginRight: '8px' }} /> 첨부파일 관리</>);
  };
  
  const closeModal = () => {
    setIsOpen(false);
  };

  const searchContract = async (params) => {
    params.sortBy = sortConfig.key;
    params.sortDir = sortConfig.direction;
    setSearchParams(params);
    dispatch(contract.request.get(params));
  }
  const formatYmd = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  const addContract = async (data) => {
    data.companySeq = session.companySeq
    await contract.request.post(data);
    searchContract({ companySeq: session.companySeq });
    refresh();
    // 요약카드 갱신 신호 + 등록일이 현재 30일 창 밖이면 range 확장되도록 입력일 전달
    setLastContractDt(data.contractDt || formatYmd(new Date()));
    setStatRefresh((n) => n + 1);
  }
  
  const updateContract = async (data , type) => {
    data.companySeq = session.companySeq
    await contract.request.put(data);
    if(!type){
      refresh();
    }
  };
  const deleteContract = async (row) => {
    const params = [row.contractSeq]
    await contract.request.delete(params)
    refresh();
    setStatRefresh((n) => n + 1);
  }

  const handleExcelUploadClick = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async () => {
      const files = Array.from(input.files || []);
      if (files.length === 0) return;
      const formData = new FormData();
      formData.append('file', files[0]);
      try {
        const result = await contractDirectApi.contract.import(formData);
        if (result && result.data) {
          setImportResult(result.data);
          setImportResultOpen(true);
        }
        searchContract({ companySeq: session.companySeq });
      } catch (e) {
        alert('엑셀 업로드 실패');
      }
    };
    input.click();
  };

  const handleExcelDownload = async () => {
    await contractDirectApi.contract.download({ companySeq: session.companySeq });
  };

  const downloadExcel = async (params) => {
    await contractDirectApi.contract.download(params);
  }

  const contractPaging = (page) => {
    setCurrentPage(page);
    searchContract({
      ...searchParams,
      companySeq: session.companySeq,
      page: page,
      size: 10
    });
  }
  const refresh = () => {
    searchContract({ companySeq: session.companySeq, page: currentPage, size: 10 });
  }

  const handleSort = (accessor) => {
    const newConfig = {
      key: accessor,
      direction: sortConfig.key === accessor && sortConfig.direction === 'desc' ? 'asc' : 'desc'
    };
    setSortConfig(newConfig);
    searchContract({
      ...searchParams,
      companySeq: session.companySeq,
      page: currentPage,
      size: 10,
      sortBy: newConfig.key,
      sortDir: newConfig.direction
    });
  }
  
  useEffect(() => {
    try {
      searchContract({ companySeq: session.companySeq });
    } catch (error) {
      console.error('Error fetching contract : ', error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, session]);
  const toggleHandler = useCallback((row) => {
    if(!row){
      return;
    }
    updateContract({confirm : !row.confirm})
  },[closeModal])

  // 1. 삭제, 2. 다운로드
  const promptContract = useCallback((contract, type, params) => {
    
    if (type === 1) {
      if (!contract) {
        return;
      }
      setModalTitle(<><FaInfo style={{ marginRight: '8px' }} /> 알림</>);
      setContent(
        <ConfirmModal
          message={`"${contract.contractNum}"을 삭제하시겠습니까?`}
          onConfirmAction={() => {
            deleteContract(contract);
            closeModal(); 
          }}
          onCancelAction={closeModal} 
          confirmText="삭제"
          cancelText="취소"
        />);
      setIsOpen(true);
    } else if (type === 2) {
      console.log('여기옴?')
      setModalTitle(<><FaInfo style={{ marginRight: '8px' }} /> 알림</>);
      setContent(
        <ConfirmModal
          message={`수주 목록을 다운로드 하시겠습니까?`}
          onConfirmAction={() => {
            downloadExcel(params);
            closeModal(); 
          }}
          onCancelAction={closeModal} 
          confirmText="다운로드"
          cancelText="취소"
        />);
      setIsOpen(true);
    }
  }, [deleteContract, closeModal]);

  return (
    <div className="contract-management">
      <ContractStatDashboard refreshSignal={statRefresh} lastContractDt={lastContractDt} />
      <Search
          search={searchContract}
          formFields={searchFormFields}
          title={"수주"}
          excel={promptContract}
      />
      {/* <button onClick={() => {test()}}> dsadsa </button> */}
      <Table
        columns={columns(openModal, promptContract, openFileModal, updateContract)}
        data={ contracts.data }
        page={ contracts.page }
        title={ <><FaClipboardList style={{ marginRight: '8px' }} /> 수주 목록</> }
        onRowClick={(row) => {}}
        showSearchBar={false}
        onAddClick={() => openModal(1)}
        paging={contractPaging}
        excelExport={handleExcelDownload}
        excelImport={handleExcelUploadClick}
        sortConfig={sortConfig}
        onSort={handleSort}
        emptyState={
          (contracts.data?.length ?? 0) === 0 ? (
            <EmptyState
              message={LIST_EMPTY.contract.message}
              hint={LIST_EMPTY.contract.hint}
              ctaLabel={LIST_EMPTY.contract.ctaLabel}
              onCta={() => openModal(1)}
            />
          ) : null
        }
      />
      <BaseModal
        children={content}
        title={modalTitle}
        isOpen={isOpen}
        onClose={closeModal}
      />
      <ExcelImportResultModal
        isOpen={importResultOpen}
        onClose={() => setImportResultOpen(false)}
        result={importResult}
      />
    </div>
  );
};
  export default ContractManagement;
